
import Immutable from 'seamless-immutable';

import { actions } from './actions';

/* ------------- Auth reducer ------------- */
const defaultState = {
  plan: null,
  error: null,
  loading: true,
  open: false,
};

/* eslint-enable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.LOAD_START: {
      return state.merge({ loading: true, open: true });
    }
    case actions.LOAD_SUCCESS: {
      return state.merge({
        loading: false,
        plan: action.payload.plan,
        error: null,
      });
    }
    case actions.LOAD_FAIL: {
      return state.merge({
        loading: false,
        error: action.payload.error,
        plan: null,
      });
    }
    case actions.OPEN_MODAL: {
      return state.merge({
        open: true,
      });
    }
    case actions.CLOSE_MODAL: {
      return state.merge({
        open: false,
      });
    }
    default: {
      return state;
    }
  }
}
/* eslint-disable complexity */

export const propTypes = {};



// WEBPACK FOOTER //
// ./src/redux/PlanModal/reducer.js